import React, { useEffect } from 'react';
// @import components
import LeftSide from './components/leftside';
import RightSide from './components/rightside';
// @import dependencies
import { useDispatch, useSelector } from 'react-redux';
// @import thunkapi
import { getAccountHolders, getDetails } from 'store/slices/homeSlice/thunkapi';

const HomePage = () => {
  const { authData } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    const payload = {
      identity: authData?.identity,
      profileName: authData?.profileName,
      parentIdentity: authData?.parentIdentity?.split('/')[0],
    };
    dispatch(getDetails(payload));
    dispatch(getAccountHolders({ identity: authData?.identity }));
  }, []);
  return (
    <div className='flex w-full flex-col space-x-3 p-10 xl:flex-row'>
      <div className=' w-full  xl:w-10/12'>
        <LeftSide />
      </div>
      <div className='w-full xl:w-2/12'>
        <RightSide />
      </div>
    </div>
  );
};

export default HomePage;
